import css from 'styled-jsx/css';
import { colors } from '../../../themes';

export default css`
  footer {
    background: ${colors.grayExtraLight};
    padding: 25px;
    text-align: center;
  }

  p {
    margin: 0;
  }

  footer :global(a) {
    color: ${colors.grayDark};
    font-size: 0.75em; /* 12/16 */
    margin: 3px 5px;
    white-space: nowrap;
    display: inline-block;
  }

  .social {
    color: ${colors.gray};
  }

  .social p {
    margin: 0 0 1em;
  }

  .social div {
    margin: 0 0 1em;
    vertical-align: middle;
  }

  .social div :global(svg) {
    margin: 0 10px;
  }
`;



// WEBPACK FOOTER //
// ./app/components/mobile/Footer/styles.js